/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMessageBanner = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M13 13h5v2h-5zm-2-4h7v2h-7zM6 9h3v2H6z" />
      <path d="M2 1v22h20V1zm18 20H4v-2h16zm0-4H4V7h16zm0-12H4V3h16z" />
      <path d="M6 13h5v2H6z" />
    </g>
  </Icon>
);
export { SvgMessageBanner as MessageBanner };
